module.exports = __webpack_public_path__ + "img/auth-bg.3f8e1e05.svg";